import { Loader2 } from "lucide-react";

export default function DailyPlanCard({ daily, loading }) {
  if (loading && !daily) {
    return <div className="mono text-sm text-zinc-500">Loading today's plan…</div>;
  }
  if (!daily) {
    return <div className="mono text-sm text-zinc-500">No plan available</div>;
  }
  return (
    <div className="space-y-3">
      <p className="font-display text-lg text-white leading-snug">
        {daily.plan.headline}
      </p>
      <div className="grid grid-cols-2 gap-3 text-sm">
        <Metric label="BASE STAKE" value={`$${daily.plan.recommended_base_stake}`} />
        <Metric label="VARIANT" value={daily.plan.recommended_variant} upper />
        <Metric label="MAX STEPS" value={daily.plan.recommended_max_steps} />
        <div>
          <div className="overline">STOP·LOSS</div>
          <div className="mono text-amber-400 text-xs leading-tight">
            {daily.plan.stop_loss_rule}
          </div>
        </div>
      </div>
      <div className="border-t border-zinc-800 pt-3 text-xs text-zinc-400 leading-relaxed">
        <span className="overline block mb-1">ROLLING STRATEGY</span>
        {daily.plan.rolling_strategy}
      </div>
    </div>
  );
}

function Metric({ label, value, upper }) {
  return (
    <div>
      <div className="overline">{label}</div>
      <div className={`mono text-[#00D4FF] text-lg ${upper ? "uppercase" : ""}`}>
        {value}
      </div>
    </div>
  );
}

export function PlaysGrid({ plays, loading, active, PlayCard }) {
  if (loading) {
    return (
      <div className="flex items-center gap-3 text-zinc-400 mono text-sm">
        <Loader2 size={16} className="animate-spin text-[#00D4FF]" /> Running handicapper
        on {active.toUpperCase()} slate…
      </div>
    );
  }
  if (plays.length === 0) {
    return (
      <div className="border border-dashed border-zinc-800 p-12 text-center">
        <div className="font-display text-2xl mb-2 text-zinc-300">No games on slate</div>
        <p className="text-zinc-500 text-sm">
          There are no {active.toUpperCase()} games scheduled to analyze right now.
        </p>
      </div>
    );
  }
  return (
    <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
      {plays.map((p) => (
        <PlayCard key={p.game_id} card={p} />
      ))}
    </div>
  );
}
